module.exports = __webpack_public_path__ + "static/Bronze_Dragon-5315f92e38f5f9c97b6ef56493b3585a.jpg";